export default __webpack_public_path__ + "static/media/about-us-timeline.ddb92063.png";